<template>
  <div>
    <el-form
      :inline="true"
      :model="addDataData"
      class="demo-form-inline"
      v-if="$permission('withdraws.setting.userBank.store')"
    >
      <el-form-item label="卡號">
        <el-input v-model="addDataData.account" placeholder="卡號"></el-input>
      </el-form-item>
      <el-form-item label="銀行名稱">
        <el-input
          v-model="addDataData.bank_name"
          placeholder="銀行名稱"
        ></el-input>
      </el-form-item>
      <el-form-item label="銀行支行">
        <el-input
          v-model="addDataData.branch"
          placeholder="銀行支行"
        ></el-input>
      </el-form-item>
      <el-form-item label="戶名">
        <el-input v-model="addDataData.name" placeholder="戶名"></el-input>
      </el-form-item>
      <el-form-item label="別名">
        <el-input v-model="addDataData.alias" placeholder="別名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addData()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-button
      v-if="$permission('withdraws.setting.userBank.destroy')"
      size="mini"
      @click="batchDel"
      >批量刪除</el-button
    >
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="selection"
        width="55"
      >
      </el-table-column>
      <af-table-column
        header-align="center"
        align="center"
        prop="alias"
        label="別名"
      >
      </af-table-column>
      <af-table-column
        header-align="center"
        align="center"
        prop="bank_name"
        label="銀行名稱"
      >
      </af-table-column>
      <af-table-column
        header-align="center"
        align="center"
        prop="branch"
        label="銀行支行"
      >
      </af-table-column>
      <af-table-column
        header-align="center"
        align="center"
        prop="name"
        label="戶名"
      >
      </af-table-column>
      <af-table-column
        header-align="center"
        align="center"
        prop="account"
        label="卡號"
      >
      </af-table-column>
      <af-table-column
        header-align="center"
        align="center"
        width="100"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              v-if="$permission('withdraws.setting.userBank.destroy')"
              size="mini"
              @click="delData(scope.row)"
              >刪除</el-button
            >
          </div>
        </template>
      </af-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addDataData: {},
      dataList: [],
      page: 1,
      inSearch: false,
      pagination: {}
    };
  },
  computed: {
    permission() {
      return this.$store.state.permissions;
    }
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    },
    permission() {
      if (this.$permission("withdraws.apply.bankAcc")) {
        this.getData();
      }
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val;
    },
    batchDel() {
      let data = JSON.parse(JSON.stringify(this.selectData));
      let sendData = [];
      data.forEach(e => {
        sendData.push(e.id);
      });
      this.$alert(`確定批量刪除?`, "刪除", {
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        beforeClose: (method, instance, done) => {
          if (method == "confirm") {
            done();
            this.$http
              .delete(`/back/withdraws/setting/user_bank`, {
                params: { ids: sendData }
              })
              .then(res => {
                if (res.data.code == 0) {
                  this.$message.success("成功");
                  this.getData();
                }
              });
          } else {
            done();
          }
        }
      });
    },
    delData(data) {
      this.$alert(`確定刪除${data.account}?`, "刪除", {
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        beforeClose: (method, instance, done) => {
          if (method == "confirm") {
            done();
            this.$http
              .delete(`/back/withdraws/setting/user_bank/${data.id}`)
              .then(res => {
                if (res.data.code == 0) {
                  this.$message.success("成功");
                  this.getData();
                }
              });
          } else {
            done();
          }
        }
      });
    },
    addData() {
      this.$http
        .post(`/back/withdraws/setting/user_bank`, this.addDataData)
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.addDataData = {};
            this.getData();
          }
        });
    },
    getData() {
      this.$http
        .get(`/back/payment/apply/bank_acc?paginate=1&page=${this.page}`)
        .then(res => {
          if (res.data.code == 0) {
            let data = res.data.data;
            if (Array.isArray(data)) {
              this.dataList = data;
            } else {
              try {
                this.dataList = Object.values(data);
              } catch (error) {
                console.log(error);
              }
            }
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    if (this.$permission("withdraws.apply.bankAcc")) {
      this.getData();
    }
  }
};
</script>
